














































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import { PermissionsModule } from '@/store/modules/permissions.module'
import { IUserChainRole } from '@zunta/configurations'
import ScrollView from '@/components/ScrollView.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import ModalV2 from '@/components/modals/ModalV2.vue'
import { required } from 'vuelidate/lib/validators'
import InputValidator from '@/components/inputsV2/InputValidator.vue'

interface IUpdatableRole {
  roleId: number;
  name: string;
}

@Component({
  components: {
    InputValidator,
    ModalV2,
    InputV2,
    LoaderWrapper,
    ScrollView,
    Icon
  }
})
export default class ModifyRoleModal extends Vue {
  permissionsModuleInstance: PermissionsModule = getModule(PermissionsModule, this.$store)
  newRoles: Partial<IUserChainRole>[] = []
  updatableRoles: IUpdatableRole[] = []
  deletableRolesIds: number[] = []
  errors: string[] = []

  isLoading: boolean = false

  validations (): any {
    return {
      rolesList: {
        $each: {
          name: {
            required,
            unique: (val: string) => {
              return !(val &&
                this.rolesToCheck.filter((role: any) => role.name.trim() === (val as string).trim()).length > 1)
            }
          }
        }
      },
      newRoles: {
        $each: {
          name: {
            required,
            unique: (val: string) => {
              return !(val &&
                this.rolesToCheck.filter((role: any) => role.name.trim() === (val as string).trim()).length > 1)
            }
          }
        }
      }
    }
  }

  get rolesToCheck () {
    return [...this.rolesList, ...this.newRoles]
  }

  get totalRolesList () {
    return this.$store.state.permissions.roles
  }

  get rolesList () {
    return this.totalRolesList.filter((role: IUserChainRole) => !this.deletableRolesIds.includes(role.id))
  }

  isAdminRole (role: IUserChainRole) {
    return role.name === 'Admin'
  }

  async markRoleForDelete (id: number) {
    try {
      this.$v.rolesList.$reset()
      this.$v.newRoles.$reset()
      this.isLoading = true
      const abilityToDelete = await this.permissionsModuleInstance.checkAbilityToDeleteRole(id)
      if (abilityToDelete) {
        this.deletableRolesIds.push(id)
        return
      }
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        header: 'You cannot delete this role',
        icon: 'warning'
      })
    } finally {
      this.isLoading = false
    }
  }

  changeRoleName (role: IUserChainRole, value: string) {
    this.$v.rolesList.$reset()
    this.$v.newRoles.$reset()

    if (this.isAdminRole(role)) {
      return
    }
    const updatableRole: IUpdatableRole | undefined = this.updatableRoles.find((roleForUpdate: IUpdatableRole) => role.id === roleForUpdate.roleId)
    if (updatableRole) {
      updatableRole.name = value.trim()
    } else {
      this.updatableRoles.push({
        roleId: role.id,
        name: value.trim()
      })
    }
  }

  addNewRole () {
    this.newRoles.push({
      name: ''
    })
    this.$v.rolesList.$reset()
    this.$v.newRoles.$reset()
  }

  deleteNewRole (roleForDelete: Partial<IUserChainRole>) {
    this.$v.rolesList.$reset()
    this.$v.newRoles.$reset()
    this.updatableRoles = this.updatableRoles.filter((role: IUpdatableRole) => role.roleId !== roleForDelete.id)
    this.newRoles = this.newRoles.filter((role: Partial<IUserChainRole>) => role !== roleForDelete)
  }

  async saveRoles () {
    this.$v.$touch()

    if (this.$v.$invalid) {
      this.$el.querySelector('.error')
      return
    }

    try {
      this.isLoading = true
      await Promise.all(
        // @ts-ignore
        [
          ...this.newRoles.map((role: Partial<IUserChainRole>) => this.permissionsModuleInstance.createUserRole(role.name as string)),
          ...this.updatableRoles.map((roleForUpdate: IUpdatableRole) => this.permissionsModuleInstance.updateUserRole(roleForUpdate)),
          ...this.deletableRolesIds.map((item: number) => this.permissionsModuleInstance.deleteUserRole(item))
        ]
      )

      this.$eventBus.$emit('notify', {
        color: 'var(--status-success-color)',
        message: `Roles successfully modified`,
        header: `Modify Roles`,
        icon: 'check'
      })
      this.$emit('close')
    } finally {
      this.isLoading = false
    }
  }
}
